export const isArray = (obj) => Object.prototype.toString.call(obj) == '[object Array]';

export const insertIntoArrayIf = (condition, ...elements) => {
  return condition ? elements : [];
};

export const filterArrayDuplicates = (existingArray: [], incomingArray: []) => {
  return Array.from(new Set([...existingArray, ...incomingArray].map(JSON.stringify)), JSON.parse);
};

export const asyncSome = async <T>(
  array: T[],
  predicate: (item: T) => Promise<boolean>
): Promise<boolean> => {
  try {
    for (const item of array) {
      if (await predicate(item)) return true;
    }
    return false;
  } catch (error) {
    throw error
  }
};

// return an array of integers from [start ...to... end) (end exclusive)
export const createRangeFromZero = (end: number, start: number = 0) => {
  const length = Math.max(0, end - start)
  return Array.from(Array(length), (_, x) => start + x)
}

/**
 * Creates a comparator function for sorting by multiple fields.
 * Supports both string (uses localeCompare) and number comparisons.
 *
 * @example
 * // Sort by name, then by age
 * items.sort(sortByFields(
 *   (item) => item.name,
 *   (item) => item.age
 * ));
 */
export const sortByFields = <T>(
  ...extractors: Array<(item: T) => string | number>
): ((a: T, b: T) => number) => {
  return (a: T, b: T): number => {
    for (const extract of extractors) {
      const valA = extract(a);
      const valB = extract(b);

      if (valA === valB) continue;

      if (typeof valA === 'string' && typeof valB === 'string') {
        const result = valA.localeCompare(valB);
        if (result !== 0) return result;
        continue;
      }

      return (valA as number) - (valB as number);
    }
    return 0;
  };
}
